import { render, staticRenderFns } from "./Pdfvuer.vue?vue&type=template&id=1c98349c&"
import script from "./Pdfvuer.vue?vue&type=script&lang=js&"
export * from "./Pdfvuer.vue?vue&type=script&lang=js&"
import style0 from "pdfjs-dist/web/pdf_viewer.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports